import { render, staticRenderFns } from "./PaymentSuccess.vue?vue&type=template&id=c0ad16e2&scoped=true"
import script from "./PaymentSuccess.vue?vue&type=script&lang=js"
export * from "./PaymentSuccess.vue?vue&type=script&lang=js"
import style0 from "./PaymentSuccess.vue?vue&type=style&index=0&id=c0ad16e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ad16e2",
  null
  
)

export default component.exports